module.exports = __webpack_public_path__ + "static/media/Материали и предложения за решения.31942c54.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Материали и предложения за решения.pdf
// module id = 102
// module chunks = 0